<div>
    <div class="grid">
        <div class="col-12 md:col-6 lg:col-6"></div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')">
        </div>
      </div>
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
            <p-table    
                    [columns]="columnas"
                    [value]="listValidityEmployees"
                    [paginator]="true"
                    [rows]="10"
                    [responsive]="true"
                    paginatorPosition="bottom"
                    #dt>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                            class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                        <td>{{row.codigoFuncionalidadControl}}</td>
                        <td>{{row.funcionalidadControl}}</td>
                        <td>{{row.vigencia}}</td>
                        <td>{{row.duracionVigencia ? row.duracionVigencia : '--'}}</td>
                        <td class="text-center">
                        <div class="btn-group" role="group">
                            <button type="button" icon="fa fa-pencil" class="ui-button-success" data-toggle="tooltip" title="{{'BTN_EDITAR' | translate}}"
                                pButton (click)="edit(row)"></button>
                        </div>
                        </td>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="text-center">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                    </tr>
                    </ng-template>
            </p-table>
        </div>
    </div>
</div>